//min site id to powered by banner A/B test

export const commonMinSiteId: number = 41030;
